import { render, staticRenderFns } from "./EmailWidget.vue?vue&type=template&id=2c3dfc22&scoped=true&"
import script from "./EmailWidget.vue?vue&type=script&lang=js&"
export * from "./EmailWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dfc22",
  null
  
)

export default component.exports